import { snakeCase, text, timestamp, unique } from 'drizzle-orm/pg-core'
import { id } from '../utils/columns.helpers'
import { accessTypeEnum } from './_common.table'
import { benefitsTable } from './benefits.table'
import { clientsTable } from './clients.table'

export const benefitClientTargetsTable = snakeCase.table(
    'benefit_client_targets',
    {
        id: id('bct'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        clientId: text()
            .notNull()
            .references(() => clientsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        accessType: accessTypeEnum().notNull(),
        createdAt: timestamp({ withTimezone: true }).defaultNow(),
    },
    (table) => [
        unique('benefit_client_unique').on(table.benefitId, table.clientId),
    ],
)
